import React, { Component } from "react";

import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import RemoveIcon from '@material-ui/icons/Remove';

class CurriculumFieldsRow extends Component {
	constructor(props) {
		super(props);
		
		this.handleChange = this.handleChange.bind(this);
		this.handleRemove = this.handleRemove.bind(this);
	}

	handleChange(e) {
		e.preventDefault();
		this.props.handleChange(this.props.index, e.target.name, e.target.value);
	}
	handleRemove(e) {
		e.preventDefault();
		this.props.handleRemove(this.props.index);
	}
	
	
	//{start, finish, institution, title}
	render() {
		return(
			<TableRow>
				<TableCell>
					<input type="text" id="start" name="start" size="10" onChange={this.handleChange} value={this.props.start}/>
				</TableCell>
				<TableCell>
					<input type="text" id="finish" name="finish" size="10" onChange={this.handleChange} value={this.props.finish}/>
				</TableCell>
				<TableCell>
					<input type="text" id="institution" name="institution" size="20" onChange={this.handleChange} value={this.props.institution}/>
				</TableCell>
				<TableCell>
					<textarea
						onChange={this.handleChange}
						style={{width: "100%"}}
						rows="1"
						id="subject"
						name="subject"
						value={this.props.subject}
					/>
				</TableCell>
				<TableCell>
					<Button variant="contained" color="primary" aria-label="Close" onClick={this.handleRemove}><RemoveIcon/></Button>
				</TableCell>
			</TableRow>
		)
	}
}

export default CurriculumFieldsRow;


				